import PropTypes from "prop-types";
import { CustomBreadcrumb, PageContent } from "components/Common";
import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PathologyCodeConfig from "./PathologyCodeConfig";

const RESOURCE = ModuleIds.PathologyCode
const PathologyCodeConfigContainer = ({ t }) => {
    const titleTag = `Pathology Code`
    return (
        <PageContent title={titleTag}>
            <CustomBreadcrumb
                breadcrumbItem={t("Pathology Code")}
                resource={RESOURCE}
            />
            <PathologyCodeConfig />
        </PageContent>
    );
}

PathologyCodeConfigContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["pathologyCodePage"])(PathologyCodeConfigContainer)